import { Link } from "react-router-dom";
import { news } from "@/mocks/news";
import SectionHeader from "@/components/base/SectionHeader";
import Tag from "@/components/base/Tag";

export default function LatestNews() {
  const latest = news.slice(0, 4);

  return (
    <section aria-label="最新资讯" className="mt-12 md:mt-16">
      <SectionHeader
        eyebrow="Latest News"
        title="最新资讯精选"
        subtitle="剧集动态、官方消息与深度解读，第一时间掌握《美国禁忌4》相关内容。"
        action={
          <Link
            to="/news"
            className="inline-flex items-center gap-2 text-sm font-label text-accent-400 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            更多资讯
            <i className="ri-arrow-right-line" />
          </Link>
        }
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
        {latest.map((item) => (
          <Link
            key={item.id}
            to={`/news/${item.id}`}
            className="group flex gap-4 rounded-lg bg-background-100 border border-background-200 hover:border-accent-500/40 transition-colors cursor-pointer p-4"
          >
            <div className="hidden sm:block w-28 h-24 shrink-0 rounded-md overflow-hidden">
              <img
                src={item.cover}
                alt={`${item.title} 配图`}
                title={`${item.title} - 美国禁忌4 资讯`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="min-w-0 flex flex-col">
              <div className="flex items-center gap-2 mb-2">
                <Tag tone="primary">{item.category}</Tag>
                <span className="text-xs text-foreground-500 font-label">{item.date}</span>
              </div>
              <h3 className="font-heading text-[15px] md:text-base leading-snug text-foreground-950 group-hover:text-accent-400 transition-colors line-clamp-2">
                {item.title}
              </h3>
              <p className="mt-2 text-[13px] text-foreground-500 leading-relaxed line-clamp-2">{item.summary}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}